
	import Vue from 'vue';
	import { mdiClose } from '@mdi/js';
	import Component from 'vue-class-component';
	import termConditionService from '@/services/api/termCondition';
	import { AxiosResponse } from 'axios';
	import { TermCondition } from '@/types';

	const Props = Vue.extend({
		props: {
			/** The v-model value */
			value: {
				type: Boolean,
				default: false
			},
			showActions: {
				type: Boolean,
				default: false
			},
			type: {
				type: String,
				required: true
			},
			scrollDown: {
				type: Boolean,
				required: false
			},
			cancelBtnText: {
				type: String,
				default: 'Refuser'
			},
			confirmBtnText: {
				type: String,
				default: 'Accepter'
			},
			title: {
				type: String,
				default: ''
			}
		}
	});

	/** The Footer of the application with the version from package.json */
	@Component<TermConditionDialog>({
		// v-model
		model: {
			prop: 'value',
			event: 'change'
		},

		watch: {
			// When the v-model is updated
			value: {
				async handler(value) {
					if (value) {
						this.fetchLastByType();
					}
				},
				// Fired when mounted
				deep: true
			}
		},

		methods: {
			onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
				if (scrollTop + clientHeight >= (scrollHeight - 1)) {
					this.isScrolled = true;
				}
			}
		}
	})

	export default class TermConditionDialog extends Props {
		mdiClose = mdiClose;
		termCondition = {} as TermCondition;
		loading = false;
		formLoading = false;
		isScrolled = false;

		/** Internal v-model for the dialog */
		get internalDialog(): boolean {
			return this.value;
		}

		set internalDialog(value: boolean) {
			this.$emit('change', value);
		}

		get disableBtn(): boolean {
			return !(this.isScrolled && this.showActions);
		}

		fetchLastByType(): void {
			this.loading = true;
			termConditionService
				.getLastByType(this.type)
				.then((response: AxiosResponse) => {
					this.termCondition = response.data;
				})
				.finally(() => this.loading = false);
		}

		getDataCyTextAttr(): string {
			return `term-condition-text-${this.type}`;
		}

		getDataCyCloseBtnAttr(): string {
			return `close-dialog-${this.type}`;
		}

		closeDialog() {
			this.$emit('change', false);
			this.$emit('logout');
			this.termCondition = {} as TermCondition;
		}

		validate(): void {
			this.formLoading = true;
			termConditionService
				.validateTermCondition(this.type, this.termCondition)
				.then(() => {
					this.$router.push({ name: 'projects' });
				})
				.finally(() => this.formLoading = false);
		}
	}
